import { render } from "./climateBox.vue?vue&type=template&id=6ae8a212&scoped=true"
import script from "./climateBox.vue?vue&type=script&lang=js"
export * from "./climateBox.vue?vue&type=script&lang=js"

import "./climateBox.vue?vue&type=style&index=0&id=6ae8a212&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae8a212"]])

export default __exports__